import '.a2{position:fixed;}.ssr-plugin'
import '.cl{top:0px;}.ssr-plugin'
import '.b7{left:0px;}.ssr-plugin'
import '.b8{right:0px;}.ssr-plugin'
import '.en{bottom:0px;}.ssr-plugin'
import '.gt{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.gu{z-index:998;}.ssr-plugin'
import '.gv{transition:opacity 0.3s ease;}.ssr-plugin'
import '.a{height:100vh;}.ssr-plugin'
import '.u{width:100%;}.ssr-plugin'
import '.af{background-color:var(--palette-white);}.ssr-plugin'
import '.gw{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.gx{z-index:999;}.ssr-plugin'
import '.c{display:flex;}.ssr-plugin'
import '.g{flex-direction:column;}.ssr-plugin'
import '.h{align-items:center;}.ssr-plugin'
import '.v{justify-content:space-between;}.ssr-plugin'
import '.bi{padding:1.5rem;}.ssr-plugin'
import '.gy{border-bottom:var(--border-default);}.ssr-plugin'
import '.bn{flex-shrink:0;}.ssr-plugin'
import '.bb{flex:1;}.ssr-plugin'
import '.at{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="a2 cl b7 b8 en gt gu gv"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="a2 cl a u af gw gx c g"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="c h v bi gy bn"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="bb at bi"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
